<template>
    <div class="home-bps">
        <div class="bp-name" v-if="ysItem.isName==0">—— {{ysItem.gnName}} ——</div>
        <div v-for="item in items">
            <Style1 v-if="item.styleNum == 1" :imgMap="item.imgMap"/>
            <Style2 v-if="item.styleNum == 2" :imgMap="item.imgMap"/>
            <Style3 v-if="item.styleNum == 3" :imgMap="item.imgMap"/>
            <Style4 v-if="item.styleNum == 4" :imgMap="item.imgMap"/>
        </div>
        <div class="bps-items">
            <div class="bps-item" v-for="spu in bps" @click="toSpuDetails(spu.itemId)">
                <img :src="spu.coverImg"
                     style="border-top-left-radius: 7px;border-top-right-radius: 7px"/>
                <div style="display: flex;flex-direction: row;margin-top: 5px">
                    <div style="display:flex;flex-direction: column;width: 60%;padding-left: 8px;height: 75px;justify-content:center;">
                        <span style="height: 23px;line-height: 23px;font-size:13px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{spu.spuName}}</span>
                        <span style="height: 20px;line-height: 20px;font-size: 11px;color:#D2D2D2;text-decoration: line-through;">原价: {{spu.costPrice}}</span>
                        <span style="height: 20px;line-height: 20px;font-size: 13px;color: #ff4d51">¥: {{spu.skuPrice}}</span>
                    </div>
                    <div style="display:flex;flex-direction: column;align-items: center;justify-content:center;width: 37%;">
                        <van-icon name="shopping-cart-o" style="font-size: 23px;margin-bottom: 2px"/>
                        <span style="font-size: 9px">已售 {{spu.salesVolume}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getDeptId} from "../../../utils/auth";
    import Style1 from "../style/style1";
    import Style2 from "../style/style2";
    import Style3 from "../style/style3";
    import Style4 from "../style/style4";

    export default {
        components: {
            Style1,
            Style2,
            Style3,
            Style4,
        },
        data() {
            return {
                deptId: '',
                phone: '',
                bps: [],
                ysItem: {},
                items: [],
            };
        },
        props: {
            item: Object
        },
        async created() {
            this.ysItem = this.item
            this.deptId = getDeptId()
            this.getStyleItems()
            this.getSpmBps()
        },
        methods: {
            async getStyleItems() {
                let data = {
                    deptId: this.deptId,
                    styleId: this.ysItem.id,
                    isShow: "0",
                }
                let res = await this.$get("/spm/getSpmStyleItems", data)
                this.items = res.list
            },
            async getSpmBps() {
                let data = {
                    deptId: this.deptId,
                    isShow: "0",
                }
                let res = await this.$get("/spm/getSpmBps", data)
                this.bps = res.list
            },
            toSpuDetails(id) {
                this.$router.push('/spuDetails/' + this.deptId + '/' + id)
            },
        },
    };
</script>

<style lang="scss" scoped>
    .home-bps {
        height: 100%;
        margin: 0 5px 5px 5px;
        background-color: #FFFFFF;
    }
    .bp-name{
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      padding: 18px 0;
    }
    .bps-items {
        display: flex;
        flex-flow: row wrap;
        font-size: 10px;
    }

    .bps-item {
        box-sizing: border-box;
        margin: 9px 10px;
        display: flex;
        flex-direction: column;
        cursor: pointer;
        width: calc((100% - 44px) / 2); // 我这里一行显示4个 所以是/4  一行显示几个就除以几
        min-width: calc((100% - 44px) / 2);
        max-width: calc((100% - 44px) / 2);
    }

</style>
